// @flow strict

export const captionFontSize = 12;
export const captionLetterSpacing = 0.4;
export const captionLineHeight = 20;
